import {
  WSCard,
  WSElement,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { WorkLog, WorkLogStatus } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { StepItem, Steps } from "../../../shared/components/Steps";

type Props = {
  workLog?: WorkLog;
  shimmer?: boolean;
};

export const WorkLogStatusStepperPayeeView: React.FC<Props> = props => {
  const steps: StepItem[] = useMemo(() => {
    const status = props.workLog?.status;
    const isApproved = status === WorkLogStatus.APPROVED;
    const isRejected = status === WorkLogStatus.REJECTED;
    const isInReview = status === WorkLogStatus.IN_REVIEW;
    const isDraftOrInProgress =
      status === WorkLogStatus.DRAFT || status === WorkLogStatus.IN_PROGRESS;

    let submittedStatus: StepItem["status"] = "Pending";
    if (isRejected) submittedStatus = "Rejected";
    else if (isInReview) submittedStatus = "Active";
    else if (isApproved) submittedStatus = "Complete";

    return [
      {
        title: "In-progress",
        status: isDraftOrInProgress ? "Active" : "Complete"
      },
      {
        title: "Submitted",
        status: submittedStatus
      },
      {
        title: "Approved",
        status: isApproved ? "Complete" : "Pending"
      }
    ];
  }, [props.workLog?.status]);

  return (
    <WSElement>
      <WSSectionToolbar title="Work log steps" />
      <WSCard shimmer={props.shimmer}>
        <Steps steps={steps} />
      </WSCard>
    </WSElement>
  );
};
